// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"3332":"e4dfdf1ad8b92206","5285":"3d799163d06c86fb"}[chunkId] + ".css";
};